import React from 'react';
import {Helper} from "../Helper";

export default class Calculator extends React.Component {
    constructor() {
        super();
        this.state = {
            array: [1, 2, 3, 4, 5, 6, 7, 8, 9, '.', 0]
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className={"calculator ui segment"} style={{flex: 1}}>
                <div className={"flex"} style={{width: '100%', height: '100%'}}>
                    <div className={"flex"} style={{flex: 1}}>
                        <div className={"flex row wrap padded three column computer wrap"}>
                            {
                                this.state.array.map((item, item_i) => (
                                    <div className={"column padded"} key={item_i}
                                         style={{marginTop: item_i > 2 ? 15 : 0}}
                                    >
                                        <button className={"ui button fluid"}
                                                ref={(ref) => {
                                                    window.$(ref).height(window.$(ref).width())
                                                }}
                                                style={{height: 57, padding: 0}}
                                                onClick={() => {
                                                    let input = window.$focus_input;
                                                    let value = input.val();
                                                    if (!input.val() || (input.val() && input.val() === '0')) {
                                                        value = item
                                                    }
                                                    if (input.val() && input.val() !== '0') {
                                                        value = value + item;
                                                    }

                                                    value = Helper.setDecimal(value);
                                                    input.val(value);
                                                    input.trigger('change');
                                                }}
                                        >
                                            {item}
                                        </button>
                                    </div>
                                ))
                            }
                            <div className={"column padded"}
                                 style={{marginTop: 15}}
                            >
                                <button className={"ui button fluid basic"}
                                        ref={(ref) => {
                                            window.$(ref).height(window.$(ref).width())
                                        }}
                                        style={{height: 57, padding: 0}}
                                        onClick={() => {
                                            let input = window.$focus_input;
                                            let value = input.val().substring(0, input.val().length - 1);
                                            if (!value || value === "") {
                                                value = 0;
                                            }
                                            value = Helper.setDecimal(value);
                                            input.val(value);
                                            input.trigger('change');
                                        }}
                                >
                                    <i className={"icon arrow left"} style={{margin: 'auto'}}/>
                                </button>
                            </div>
                        </div>
                        <div>
                            <button className={"ui button fluid basic custom-submit-btn"}
                                    onClick={() => {
                                        let input = window.$focus_input;
                                        let value = '0';
                                        if (!value || value === "") {
                                            value = 0;
                                        }
                                        value = Helper.setDecimal(value);
                                        input.val(value);
                                        input.trigger('change');
                                    }}
                            >
                                Clear
                            </button>
                        </div>
                    </div>
                    {/*<div style={{marginTop: 15}}>*/}
                    {/*    <button className={"ui button fluid green custom-submit-btn"}*/}
                    {/*            onClick={() => {*/}
                    {/*                this.props.closeCalculator();*/}
                    {/*            }}*/}
                    {/*    >*/}
                    {/*        ปิด*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
            </div>
        );
    }
}